<template>
  <div class="searchList">
    <div class="searchList-header">
      <div class="header-left">
        排序：<el-radio v-model="orderSort" label="1">按日期由近及远</el-radio>
        <el-radio v-model="orderSort" label="2">按日期由远及近</el-radio>
      </div>
      <div class="header-right">
        <el-date-picker
          v-model="searchTime"
          type="daterange"
          size="mini"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="changeTime"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="searchList-content" v-if="dataLength">
      <div
        class="content-item"
        v-for="(cusitem, index) in itemList"
        :key="index"
      >
        <template v-if="gwSearch && gwSearch[cusitem.num]">
          <div class="item-body">
            <div class="item-body-top">
              <div>{{ cusitem.title }}</div>
              <div>相关结果约{{ gwSearch && gwSearch[cusitem.num] }}条</div>
            </div>
            <div
              class="item-body-list"
              v-for="(item, index) in gwSearch && gwSearch[cusitem.option]"
              :key="index"
              @click="toDetails(cusitem, item)"
            >
              <div v-html="showKeyWord(item.title, searchValue)"></div>
              <div>{{ parseTime(item.addTime) }}</div>
            </div>
          </div>
          <div class="more" @click="checkMore(cusitem)">
            <p>更</p>
            <p>多</p>
          </div>
        </template>
      </div>
    </div>
    <div class="empty" v-else>
      <div class="empty-text">
        未搜索到与“<span v-html="showKeyWord(searchValue, searchValue)"></span
        >”相关的内容，请更其他换搜索词重新搜索
      </div>
      <div class="empty-img">
        <img src="@/assets/wenjian.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { globalSearch } from "@/api/search";
export default {
  data() {
    return {
      radio: "1",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      searchTime: [],
      //   gwSearch: {},
      //   searchValue: "",
      itemList: [
        {
          title: "通知公告",
          num: "noticeNum",
          option: "notices",
          type: "notice",
        },
        {
          title: "案例展示",
          num: "caseNum",
          option: "cases",
          type: "case",
        },
        {
          title: "仪器样例",
          num: "equipNum",
          option: "equips",
          type: "equip",
        },
        {
          title: "政策文件",
          num: "policyNum",
          option: "policys",
          type: "policy",
        },
        {
          title: "常见问题",
          num: "questionsNum",
          option: "questions",
          type: "question",
        },
      ],
      orderSort: "1",
      dateBegin: "",
      dateEnd: "",
    };
  },
  computed: {
    ...mapState(["searchValue", "gwSearch"]),
    dataLength() {
      return (
        this.gwSearch.caseNum +
        this.gwSearch.equipNum +
        this.gwSearch.noticeNum +
        this.gwSearch.policyNum +
        this.gwSearch.questionNum
      );
    },
  },
  watch: {
    orderSort() {
      this.globalSearch();
    },
  },
  methods: {
    changeTime(val) {
      if (val) {
        this.dateBegin = val[0];
        this.dateEnd = val[1];
      } else {
        this.dateBegin = "";
        this.dateEnd = "";
      }
      this.globalSearch();
    },
    async globalSearch() {
      const res = await globalSearch({
        title: this.searchValue,
        orderSort: this.orderSort,
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
      });
      const gwSearch = res.data.gwSearch;
      this.$store.commit("getGwSearch", gwSearch);
      //this.$store.commit("getSearchValue", this.input);
      this.$router.push({ path: "/searchList" }, () => {});
    },
    checkMore(cusitem) {
      this.$router.push({
        path: cusitem.type + "List",
        query: {
          searchValue: this.searchValue,
          fileSort: this.gwSearch[cusitem.option].length
            ? this.gwSearch[[cusitem.option]][0].fileSort
            : null,
        },
      });
    },
    toDetails(cusitem, item) {
      let routeData = this.$router.resolve({
        path: cusitem.type + "Details",
        query: {
          keyId: item.keyId,
        },
      });
      window.open(routeData.href, '_blank')
    },
  },
};
</script>

<style lang="less" scoped>
.searchList {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
}
.empty {
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .empty-text {
    margin-top: 50px;
  }
  .empty-img {
    margin-top: 70px;
    > img {
      width: 188px;
      height: 222px;
      object-fit: cover;
    }
  }
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #e21534;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #e21534;
  background: #e21534;
}
.searchList-header {
  display: flex;
  justify-content: space-between;
  padding: 20px 50px;
  box-sizing: border-box;
}
.searchList-content {
  .content-item {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .item-body {
      width: 100%;
      height: 150px;
      padding: 20px;
      box-sizing: border-box;
      background: rgba(111, 111, 111, 0.05);
      margin-bottom: 20px;
      .item-body-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        > div:nth-child(1) {
          width: 110px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          background: #a30014;
        }
      }
      .item-body-list {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3px;
        cursor: pointer;
      }
    }
    .more {
      width: 32px;
      height: auto;
      background: #a30014;
      color: #fff;
      margin-bottom: 20px;
      //padding: 20px 0;
      box-sizing: border-box;
      text-align: center;
      cursor: pointer;
      > p:nth-child(1) {
        margin-top: 50px;
      }
      > p:nth-child(2) {
        margin-top: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/search/searchList.vue